import React, { useEffect, useState } from 'react';

import { Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, TextField } from '@mui/material';

import useLogin from './useLogin';
import Button from 'components/Button';
import ChangePasswordModal from 'components/ChangePasswordModal';
import { useInitialization } from 'components/InitializationProvider';
import {
  OnboardingContentCenter,
  OnboardingForm,
  OnboardingInputsContainer,
  OnboardingLayout,
  OnboardingRememberForgotContainer,
  OnboardingTopButton,
} from 'components/OnboardingComponents';
import Text from 'components/Text';
import SuccessModal from 'pages/Register/components/SuccessModal';

export const Login: React.FC = () => {
  const {
    control,
    errors,
    loading,
    handleSubmit,
    onSubmit,
    showChangePasswordModal,
    session,
    email,
    setShowChangePasswordModal,
  } = useLogin();
  const { shouldShowLoader } = useInitialization();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [inviteeName, setInviteeName] = useState<string | null>(null);

  useEffect(() => {
    if (window.location.pathname === '/login' && !window.location.hash.includes('reloaded')) {
      window.location.replace('/login#reloaded');
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const success = localStorage.getItem('isSuccessFinal');
    const storedInviteeName = localStorage.getItem('inviteeName');
    if (success === 'true') {
      setInviteeName(storedInviteeName);
      setShowSuccessModal(true);
      localStorage.removeItem('isSuccessFinal');
      localStorage.removeItem('inviteeName');
    }
  }, []);

  const toggleShowPassword = () => setShowPassword(!showPassword);

  const handleRememberMeChange = (status: boolean) => {
    setRememberMe(status);
  };

  const navigateToForgotPassword = () => {
    navigate('/forgot-password');
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  return (
    <OnboardingLayout>
      <OnboardingForm onSubmit={handleSubmit(onSubmit)}>
        <OnboardingContentCenter>
          <Text size="medium" color="textPrimary">
            Entre com e-mail e senha
          </Text>

          <OnboardingInputsContainer>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="E-mail"
                  variant="outlined"
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  size="medium"
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Senha"
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  fullWidth
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  size="medium"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </OnboardingInputsContainer>

          <OnboardingTopButton>
            <OnboardingRememberForgotContainer>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={e => handleRememberMeChange(e.target.checked)}
                  />
                }
                label="Lembrar-me"
              />

              <Button
                type="button"
                title="Esqueceu sua senha?"
                size="medium"
                variant="minimal"
                onClick={navigateToForgotPassword}
              >
                Esqueceu sua senha?
              </Button>
            </OnboardingRememberForgotContainer>
            <Button
              type="submit"
              variant="primary"
              color="primary"
              fullWidth
              disabled={loading}
              onClick={handleSubmit(onSubmit)}
            >
              {loading ? 'Carregando...' : 'Entrar'}
            </Button>
          </OnboardingTopButton>
        </OnboardingContentCenter>

        {/* <OnboardingFooterButton>
          <OnboardingSeparator>
            <Text color="white" textAlign="center">
              Não tem uma conta?
            </Text>
          </OnboardingSeparator>
          <Button
            type="button"
            title="Registrar-se"
            size="medium"
            variant="primary"
            onClick={navigateToRegister}
            style={{
              width: '10rem',
              alignSelf: 'center',
              justifyContent: 'center',
            }}
            disabled
          >
            Registrar-se
          </Button>
        </OnboardingFooterButton> */}
      </OnboardingForm>

      {/* Só mostra Spin local se não estiver no sistema centralizado */}
      {/*       {loading && !shouldShowLoader && <Spin fullscreen />}
       */}
      {showChangePasswordModal && (
        <ChangePasswordModal
          open={showChangePasswordModal}
          onClose={() => setShowChangePasswordModal(false)}
          session={session || ''}
          email={email}
        />
      )}

      {showSuccessModal && (
        <SuccessModal
          isOpen={showSuccessModal}
          onClose={handleCloseModal}
          inviteeName={inviteeName}
        />
      )}
    </OnboardingLayout>
  );
};
